import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Loader2.css";
import fressassesment from "../../assets/asessmentbg-Photoroom-Photoroom.png";

const FreeAssesment = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 640);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setMessage("");
      setIsError(false);
      console.log("URL", process.env.REACT_APP_BACKEND_URL);
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/freeassesment/userdetailforassesment`,
        { email }
      );

      setMessage(response.data.message || "Submission successful!");
      localStorage.setItem("userEmail", email);
      navigate("/test-assesment-books");
    } catch (error) {
      setIsError(true);
      setMessage(
        error.response?.data?.message ||
        "Something went wrong. Please try again."
      );
    }
  };
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 640);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const backgroundStyle = {
    overflow: "hidden",
    margin: 0,
    padding: 0,
    backgroundColor: "#f3f4f6",
    ...(isSmallScreen
      ? {}
      : {
        backgroundImage: `url(${fressassesment})`,
        backgroundSize: "110% 155%",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }),
  };

  return (
    <div
      className="w-full flex flex-col items-center justify-center min-h-[86vh]"
      style={backgroundStyle}
    >
      <div className="py-6 md:py-10 px-4 sm:px-6 md:px-8 rounded-lg w-full sm:w-5/6 md:w-3/4 lg:w-1/2 mx-4 my-4 bg-white bg-opacity-80">
        <h2 className="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-6">
          Student Information
        </h2>

        {message && (
          <div
            className={`p-3 mb-4 text-sm rounded-lg ${isError
              ? "bg-red-100 text-red-700"
              : "bg-green-100 text-green-700"
              }`}
          >
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-600"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 p-2 sm:p-3 w-full border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Enter your email"
              required
            />
            <p className="mt-2 text-xs sm:text-sm text-gray-500">
              <strong>Email Address:</strong> This email will be used to send
              the report once the student has finished the free assessment.
            </p>
          </div>

          <div className="mt-4 sm:mt-6 p-3 sm:p-4 border border-gray-300 rounded-lg">
            <h3 className="text-md sm:text-lg font-semibold text-gray-700 mb-2">
              Instructions for the Free Assessment
            </h3>
            <p className="text-xs sm:text-sm text-gray-600 mb-2">
              Please read the instructions carefully before commencing the test.
            </p>
            <ul className="list-decimal list-inside text-xs sm:text-sm text-gray-600 space-y-1 sm:space-y-2 pl-2">
              <li>
                There are 3 assessments of Reading, Mathematical Reasoning, and
                Thinking Skills in this session.
              </li>
              <li>
                After you have selected an answer, click the{" "}
                <strong>NEXT</strong> button (bottom right-hand) to proceed to
                the following question.
              </li>
              <li>
                If you want to revisit any of your previously selected answers,
                click the <strong>Previous</strong> button (bottom right-hand).
              </li>
              <li>
                You can change your answer anytime within the allocated test
                time.
              </li>
              <li>
                Click <strong>Submit</strong> once you finish the test.
              </li>
            </ul>
            <p className="mt-3 sm:mt-4 font-semibold text-gray-700 text-sm sm:text-base">All the best!</p>
          </div>

          <div className="w-full flex">
            <button
              type="submit"
              className="w-full sm:w-1/2 mx-auto py-2 sm:py-3 mt-4 text-black bg-yellow-400 font-semibold rounded-lg hover:bg-yellow-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-400"
            >
              Start
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FreeAssesment;